import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var AnnualDiscountKind;
(function (AnnualDiscountKind) {
    AnnualDiscountKind["Percent"] = "PERCENT";
    AnnualDiscountKind["Period"] = "PERIOD";
})(AnnualDiscountKind || (AnnualDiscountKind = {}));
export var BusinessSegment;
(function (BusinessSegment) {
    BusinessSegment["Events"] = "EVENTS";
    BusinessSegment["Retail"] = "RETAIL";
})(BusinessSegment || (BusinessSegment = {}));
export var CampaignGoalKind;
(function (CampaignGoalKind) {
    CampaignGoalKind["AnnualRevenue"] = "ANNUAL_REVENUE";
    CampaignGoalKind["Members"] = "MEMBERS";
    CampaignGoalKind["MonthlyRevenue"] = "MONTHLY_REVENUE";
})(CampaignGoalKind || (CampaignGoalKind = {}));
export var CurationMatchMode;
(function (CurationMatchMode) {
    CurationMatchMode["Product"] = "PRODUCT";
    CurationMatchMode["Variant"] = "VARIANT";
})(CurationMatchMode || (CurationMatchMode = {}));
export var CurationStatus;
(function (CurationStatus) {
    CurationStatus["Approved"] = "APPROVED";
    CurationStatus["Flagged"] = "FLAGGED";
    CurationStatus["Proposed"] = "PROPOSED";
})(CurationStatus || (CurationStatus = {}));
export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Pickup"] = "PICKUP";
    DeliveryMethod["Shipping"] = "SHIPPING";
})(DeliveryMethod || (DeliveryMethod = {}));
export var DeliveryStrategy;
(function (DeliveryStrategy) {
    DeliveryStrategy["Annual"] = "ANNUAL";
    DeliveryStrategy["Biweekly"] = "BIWEEKLY";
    DeliveryStrategy["Custom"] = "CUSTOM";
    DeliveryStrategy["Immediately"] = "IMMEDIATELY";
    DeliveryStrategy["Monthly"] = "MONTHLY";
    DeliveryStrategy["Once"] = "ONCE";
    DeliveryStrategy["Quarterly"] = "QUARTERLY";
    DeliveryStrategy["Weekly"] = "WEEKLY";
})(DeliveryStrategy || (DeliveryStrategy = {}));
export var DiscountPlatform;
(function (DiscountPlatform) {
    DiscountPlatform["Eventbrite"] = "EVENTBRITE";
    DiscountPlatform["Shopify"] = "SHOPIFY";
    DiscountPlatform["Square"] = "SQUARE";
})(DiscountPlatform || (DiscountPlatform = {}));
export var DiscountScope;
(function (DiscountScope) {
    DiscountScope["Event"] = "EVENT";
    DiscountScope["Retail"] = "RETAIL";
})(DiscountScope || (DiscountScope = {}));
export var FulfillmentInvoiceStatus;
(function (FulfillmentInvoiceStatus) {
    FulfillmentInvoiceStatus["Draft"] = "DRAFT";
    FulfillmentInvoiceStatus["Finalized"] = "FINALIZED";
    FulfillmentInvoiceStatus["Paid"] = "PAID";
})(FulfillmentInvoiceStatus || (FulfillmentInvoiceStatus = {}));
export var MembershipCancellationReason;
(function (MembershipCancellationReason) {
    MembershipCancellationReason["ByOrganizer"] = "By_Organizer";
    MembershipCancellationReason["DidNotUse"] = "Did_Not_Use";
    MembershipCancellationReason["HardToUse"] = "Hard_To_Use";
    MembershipCancellationReason["LifeIsHard"] = "Life_Is_Hard";
    MembershipCancellationReason["Other"] = "Other";
    MembershipCancellationReason["PrePurchase"] = "Pre_Purchase";
})(MembershipCancellationReason || (MembershipCancellationReason = {}));
export var MembershipKind;
(function (MembershipKind) {
    MembershipKind["Friend"] = "Friend";
    MembershipKind["Honorary"] = "Honorary";
    MembershipKind["Legacy"] = "Legacy";
    MembershipKind["Live"] = "Live";
    MembershipKind["Retired"] = "Retired";
})(MembershipKind || (MembershipKind = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["Active"] = "Active";
    MembershipStatus["Cancelled"] = "Cancelled";
    MembershipStatus["Ended"] = "Ended";
    MembershipStatus["New"] = "New";
})(MembershipStatus || (MembershipStatus = {}));
export var MoneyFormat;
(function (MoneyFormat) {
    MoneyFormat["Presentment"] = "Presentment";
    MoneyFormat["Shop"] = "Shop";
})(MoneyFormat || (MoneyFormat = {}));
export var Ordering;
(function (Ordering) {
    Ordering["Asc"] = "ASC";
    Ordering["Desc"] = "DESC";
})(Ordering || (Ordering = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Charged"] = "CHARGED";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Finalized"] = "FINALIZED";
    PaymentStatus["Ignore"] = "IGNORE";
    PaymentStatus["ItemCharged"] = "ITEM_CHARGED";
    PaymentStatus["MembershipCharged"] = "MEMBERSHIP_CHARGED";
    PaymentStatus["New"] = "NEW";
    PaymentStatus["OffPlatform"] = "OFF_PLATFORM";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var Period;
(function (Period) {
    Period["Day"] = "DAY";
    Period["Month"] = "MONTH";
    Period["Week"] = "WEEK";
    Period["Year"] = "YEAR";
})(Period || (Period = {}));
export var PlanKind;
(function (PlanKind) {
    PlanKind["Annual"] = "ANNUAL";
    PlanKind["Monthly"] = "MONTHLY";
    PlanKind["Weekly"] = "WEEKLY";
})(PlanKind || (PlanKind = {}));
export var PlatformIdKind;
(function (PlatformIdKind) {
    PlatformIdKind["DraftOrder"] = "DraftOrder";
    PlatformIdKind["Order"] = "Order";
})(PlatformIdKind || (PlatformIdKind = {}));
export var PlatformMode;
(function (PlatformMode) {
    PlatformMode["InStore"] = "IN_STORE";
    PlatformMode["Online"] = "ONLINE";
})(PlatformMode || (PlatformMode = {}));
export var PlatformName;
(function (PlatformName) {
    PlatformName["Basil"] = "BASIL";
    PlatformName["Bookmanager"] = "BOOKMANAGER";
    PlatformName["Clover"] = "CLOVER";
    PlatformName["Direct"] = "DIRECT";
    PlatformName["Eventbrite"] = "EVENTBRITE";
    PlatformName["Indiecommerce"] = "INDIECOMMERCE";
    PlatformName["Indiecommerce2"] = "INDIECOMMERCE2";
    PlatformName["Lightspeed"] = "LIGHTSPEED";
    PlatformName["Other"] = "OTHER";
    PlatformName["Shopify"] = "SHOPIFY";
    PlatformName["Square"] = "SQUARE";
    PlatformName["Squarespace"] = "SQUARESPACE";
    PlatformName["Toast"] = "TOAST";
})(PlatformName || (PlatformName = {}));
export var ThemeBadgeAlignment;
(function (ThemeBadgeAlignment) {
    ThemeBadgeAlignment["Left"] = "LEFT";
    ThemeBadgeAlignment["Right"] = "RIGHT";
})(ThemeBadgeAlignment || (ThemeBadgeAlignment = {}));
export var TransactionKind;
(function (TransactionKind) {
    TransactionKind["Addon"] = "Addon";
    TransactionKind["Base"] = "Base";
})(TransactionKind || (TransactionKind = {}));
export var VideoPlatform;
(function (VideoPlatform) {
    VideoPlatform["Vimeo"] = "VIMEO";
    VideoPlatform["Youtube"] = "YOUTUBE";
})(VideoPlatform || (VideoPlatform = {}));
export const UpdateUserFragmentDoc = gql `
    fragment UpdateUser on User {
  phoneNumber
}
    `;
export const ChooseSubscriptionScreenAddressFragmentDoc = gql `
    fragment ChooseSubscriptionScreenAddress on Address {
  shippingName
  line1
  line2
  city
  state
  zip
  country
}
    `;
export const UpdateUserInputFragmentDoc = gql `
    fragment UpdateUserInput on User {
  ...UpdateUser
  address {
    ...ChooseSubscriptionScreenAddress
  }
}
    ${UpdateUserFragmentDoc}
${ChooseSubscriptionScreenAddressFragmentDoc}`;
export const UpdateUserFulfillmentAddressFragmentDoc = gql `
    fragment UpdateUserFulfillmentAddress on Fulfillment {
  address {
    ...ChooseSubscriptionScreenAddress
  }
}
    ${ChooseSubscriptionScreenAddressFragmentDoc}`;
export const ChooseSubscriptionScreenVariantFragmentDoc = gql `
    fragment ChooseSubscriptionScreenVariant on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
}
    `;
export const ChooseSubscriptionScreenAddonFragmentDoc = gql `
    fragment ChooseSubscriptionScreenAddon on Addon {
  id
  description
  platformId
  platformName
  additionalCost {
    amount
  }
  applyDiscount
}
    `;
export const ChooseSubscriptionScreenProductFragmentDoc = gql `
    fragment ChooseSubscriptionScreenProduct on Product {
  id
  name
  platformId
  platformName
  platformVariantsOnlyMode
  curationValue
  variants {
    ...ChooseSubscriptionScreenVariant
  }
}
    ${ChooseSubscriptionScreenVariantFragmentDoc}`;
export const ChooseProductSelectionFragmentDoc = gql `
    fragment ChooseProductSelection on ProductSelection {
  product {
    ...ChooseSubscriptionScreenProduct
  }
  variant {
    ...ChooseSubscriptionScreenVariant
  }
}
    ${ChooseSubscriptionScreenProductFragmentDoc}
${ChooseSubscriptionScreenVariantFragmentDoc}`;
export const SaveFulfillmentSettingsFragmentDoc = gql `
    fragment SaveFulfillmentSettings on Fulfillment {
  id
  fulfillmentDate
  fulfillmentDateAdjustmentReason
  deliveryMethod
  benefit {
    id
    ... on SubscriptionBenefit {
      claimable
    }
    ... on WelcomeGiftBenefit {
      claimable
    }
    ... on DriveBenefit {
      claimable
    }
  }
  variant {
    ...ChooseSubscriptionScreenVariant
  }
  addons {
    ...ChooseSubscriptionScreenAddon
  }
  address {
    ...ChooseSubscriptionScreenAddress
  }
  productSelections {
    ...ChooseProductSelection
  }
  shippingNotes
  platformLineItems {
    quantity
    platformProductVariantId
    swapped
  }
}
    ${ChooseSubscriptionScreenVariantFragmentDoc}
${ChooseSubscriptionScreenAddonFragmentDoc}
${ChooseSubscriptionScreenAddressFragmentDoc}
${ChooseProductSelectionFragmentDoc}`;
export const OtherUnfulfilledFulfillmentsFragmentDoc = gql `
    fragment OtherUnfulfilledFulfillments on Fulfillment {
  membership {
    unfulfilledFulfillments: fulfillments(query: {isFulfilled: false}) {
      fulfillmentDate
      deliveryMethod
      id
      benefit {
        id
      }
      address {
        ...ChooseSubscriptionScreenAddress
      }
      variant {
        ...ChooseSubscriptionScreenVariant
      }
      addons {
        ...ChooseSubscriptionScreenAddon
      }
      productSelections {
        ...ChooseProductSelection
      }
      shippingNotes
    }
  }
}
    ${ChooseSubscriptionScreenAddressFragmentDoc}
${ChooseSubscriptionScreenVariantFragmentDoc}
${ChooseSubscriptionScreenAddonFragmentDoc}
${ChooseProductSelectionFragmentDoc}`;
export const UpdateProductSelectionFragmentDoc = gql `
    fragment UpdateProductSelection on Fulfillment {
  productSelections {
    ...ChooseProductSelection
  }
}
    ${ChooseProductSelectionFragmentDoc}`;
export const UpdateBusinessFragmentDoc = gql `
    fragment UpdateBusiness on Business {
  id
  oneLiner
  mission
  enablePastCustomerUpsell
  enableEmailUpsell
  enableSmsUpsell
  enableRedirectUpsell
  enableTips
  enableProductSwapping
  enableAutomatedCuration
  enableFAQ
  enableBadge
  enableNavigationLink
  enableAddToCartUpsell
  enableSidebarUpsell
  includeWelcomeGiftInFirstShipment
}
    `;
export const MarkArchivedFragmentDoc = gql `
    fragment MarkArchived on Fulfillment {
  isArchived
}
    `;
export const MarkFulfilledFragmentDoc = gql `
    fragment MarkFulfilled on Fulfillment {
  isFulfilled
}
    `;
export const MarkReadyForPickupFragmentDoc = gql `
    fragment MarkReadyForPickup on Fulfillment {
  isReadyForPickup
}
    `;
export const DeleteMembershipTierBusinessFragmentDoc = gql `
    fragment DeleteMembershipTierBusiness on MembershipTier {
  id
  business {
    id
  }
}
    `;
export const VariantPanelFragmentDoc = gql `
    fragment VariantPanel on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
  curationExcludeProducts
  curationIncludeVariants
  curationSearchTerms
  curationStatus
  curationError
  flagReason
}
    `;
export const SubscriptionBenefitProductFragmentDoc = gql `
    fragment SubscriptionBenefitProduct on Product {
  id
  name
  platformId
  platformName
  platformVariantsOnlyMode
  curationValue
  curationCollections
  curationExcludeProducts
  variants {
    ...VariantPanel
  }
}
    ${VariantPanelFragmentDoc}`;
export const AddonPanelFragmentDoc = gql `
    fragment AddonPanel on Addon {
  id
  description
  applyDiscount
  dontRollOver
  platformId
  platformName
  additionalCost {
    amount
  }
}
    `;
export const SubscriptionBenefitPreferNetworkFragmentDoc = gql `
    fragment SubscriptionBenefitPreferNetwork on SubscriptionBenefit {
  id
  isAddonOnly
  products {
    ...SubscriptionBenefitProduct
  }
  variants {
    ...VariantPanel
  }
  addons {
    ...AddonPanel
  }
  recentFulfillments {
    platformLineItems {
      platformProductVariantId
      swapped
    }
  }
  business {
    id
    enableAutomatedCuration
    enableProductSwapping
    includeWelcomeGiftInFirstShipment
    status
    shopifyShop
    stripeId
  }
  shopifyProductIds
}
    ${SubscriptionBenefitProductFragmentDoc}
${VariantPanelFragmentDoc}
${AddonPanelFragmentDoc}`;
export const SubscriptionBenefitPreferCacheFragmentDoc = gql `
    fragment SubscriptionBenefitPreferCache on SubscriptionBenefit {
  id
  name
  membershipTiers {
    id
    name
    members(status: Active) {
      id
    }
    plans {
      kind
      price {
        amount
      }
    }
  }
  delivery
  deliveryFrequency
  shippingFrequency {
    number
    period
  }
  firstShipmentDelay
  nextShipmentDate
  shippingNotesInstructions
  curationPreferOverstock
  curationMatchMode
  pickupEnabled
  shippingIncluded
  shippingEnabled
  shippingCost {
    amount
  }
  claimable
}
    `;
export const DriveBenefitPreferNetworkFragmentDoc = gql `
    fragment DriveBenefitPreferNetwork on DriveBenefit {
  id
  products {
    ...SubscriptionBenefitProduct
  }
  business {
    id
    enableAutomatedCuration
    enableProductSwapping
    includeWelcomeGiftInFirstShipment
    status
  }
}
    ${SubscriptionBenefitProductFragmentDoc}`;
export const DriveBenefitPreferCacheFragmentDoc = gql `
    fragment DriveBenefitPreferCache on DriveBenefit {
  id
  name
  shippingNotesInstructions
  pickupEnabled
  shippingEnabled
  shippingCost {
    amount
  }
  claimable
}
    `;
export const WelcomeGiftBenefitPreferNetworkFragmentDoc = gql `
    fragment WelcomeGiftBenefitPreferNetwork on WelcomeGiftBenefit {
  id
  products {
    ...SubscriptionBenefitProduct
  }
  variants {
    ...VariantPanel
  }
  business {
    id
    enableAutomatedCuration
    enableProductSwapping
    includeWelcomeGiftInFirstShipment
    status
  }
  shopifyProductIds
}
    ${SubscriptionBenefitProductFragmentDoc}
${VariantPanelFragmentDoc}`;
export const WelcomeGiftBenefitPreferCacheFragmentDoc = gql `
    fragment WelcomeGiftBenefitPreferCache on WelcomeGiftBenefit {
  id
  name
  membershipTiers {
    id
    name
  }
  delivery
  shippingNotesInstructions
  pickupEnabled
  shippingEnabled
  shippingCost {
    amount
  }
  claimable
}
    `;
export const AddVariantFragmentDoc = gql `
    fragment AddVariant on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
  curationExcludeProducts
  curationIncludeVariants
  curationSearchTerms
  curationStatus
  curationError
  flagReason
}
    `;
export const AddAddonFragmentDoc = gql `
    fragment AddAddon on Addon {
  id
  description
  additionalCost {
    amount
  }
  applyDiscount
  dontRollOver
  platformId
  platformName
}
    `;
export const UpdateSubscriptionBenefitFragmentDoc = gql `
    fragment UpdateSubscriptionBenefit on SubscriptionBenefit {
  name
  delivery
  nextShipmentDate
  deliveryFrequency
  firstShipmentDelay
  shippingFrequency {
    number
    period
  }
  shippingNotesInstructions
  curationPreferOverstock
  curationMatchMode
  pickupEnabled
  claimable
  shippingEnabled
  shippingCost {
    amount
  }
}
    `;
export const UpdateWelcomeGiftBenefitFragmentDoc = gql `
    fragment UpdateWelcomeGiftBenefit on WelcomeGiftBenefit {
  name
  shippingNotesInstructions
  pickupEnabled
  shippingEnabled
  claimable
  shippingCost {
    amount
  }
}
    `;
export const UpdateDriveBenefitFragmentDoc = gql `
    fragment UpdateDriveBenefit on DriveBenefit {
  name
  shippingNotesInstructions
  pickupEnabled
  shippingEnabled
  claimable
  shippingCost {
    amount
  }
}
    `;
export const UpdateSubscriptionBenefitShippingFrequencyFragmentDoc = gql `
    fragment UpdateSubscriptionBenefitShippingFrequency on SubscriptionBenefit {
  shippingFrequency {
    number
    period
  }
}
    `;
export const SaveMembershipsFragmentDoc = gql `
    fragment SaveMemberships on Business {
  membershipTiers(kind: Live) {
    id
    name
    defaultMode
    overridePlatformProductSync
    plans {
      kind
      price {
        amount
      }
    }
    discounts {
      scope
      percentage
      guests
    }
    welcomeGift {
      __typename
      id
      name
      shippingNotesInstructions
      products {
        id
        name
        platformId
        platformName
        platformVariantsOnlyMode
        variants {
          id
          description
          additionalCost {
            amount
          }
          platformName
          platformId
        }
      }
      variants {
        id
        description
        additionalCost {
          amount
        }
        platformName
        platformId
      }
    }
    benefits {
      __typename
      id
      name
      ... on RegularBenefit {
        order
      }
      ... on SubscriptionBenefit {
        delivery
        nextShipmentDate
        isAddonOnly
        shippingFrequency {
          number
          period
        }
        deliveryFrequency
        firstShipmentDelay
        shippingIncluded
        shippingWeight
        shippingNotesInstructions
        curationMatchMode
        curationPreferOverstock
        products {
          id
          name
          platformId
          platformName
          platformVariantsOnlyMode
          curationValue
          curationCollections
          curationExcludeProducts
          variants {
            id
            description
            additionalCost {
              amount
            }
            platformName
            platformId
            curationExcludeProducts
            curationIncludeVariants
            curationSearchTerms
            curationStatus
          }
        }
        variants {
          id
          description
          additionalCost {
            amount
          }
          platformName
          platformId
        }
        addons {
          id
          description
          applyDiscount
          dontRollOver
          platformId
          platformName
          additionalCost {
            amount
          }
        }
      }
    }
  }
}
    `;
export const SimpleBenefitFragmentFragmentDoc = gql `
    fragment SimpleBenefitFragment on Benefit {
  name
}
    `;
export const UpdateWelcomeGiftBenefitNameFragmentDoc = gql `
    fragment UpdateWelcomeGiftBenefitName on WelcomeGiftBenefit {
  name
}
    `;
export const UpdateBenefitDeliveryComplexFragmentDoc = gql `
    fragment UpdateBenefitDeliveryComplex on SubscriptionBenefit {
  delivery
  deliveryFrequency
  shippingFrequency {
    __typename
    number
    period
  }
  firstShipmentDelay
}
    `;
export const UpdateBenefitDeliverySimpleFragmentDoc = gql `
    fragment UpdateBenefitDeliverySimple on SubscriptionBenefit {
  delivery
}
    `;
export const UpdateBenefitNameFragmentDoc = gql `
    fragment UpdateBenefitName on Benefit {
  name
}
    `;
export const UpdateBenefitOrderFragmentDoc = gql `
    fragment UpdateBenefitOrder on RegularBenefit {
  order
}
    `;
export const UpdateBrandFragmentV1FragmentDoc = gql `
    fragment UpdateBrandFragmentV1 on Business {
  id
  oneLiner
  mission
  enableEmailUpsell
  enableSmsUpsell
  enablePastCustomerUpsell
  enableRedirectUpsell
  enableTips
}
    `;
export const UpdateBrandFragmentV2FragmentDoc = gql `
    fragment UpdateBrandFragmentV2 on Business {
  id
  oneLiner
  mission
  enableEmailUpsell
  enableSmsUpsell
  enablePastCustomerUpsell
  enableRedirectUpsell
  enableFAQ
  enableBadge
  enableNavigationLink
  enableAddToCartUpsell
  enableSidebarUpsell
}
    `;
export const UpdateBusinessFieldInputFragmentDoc = gql `
    fragment UpdateBusinessFieldInput on Business {
  mission
  oneLiner
}
    `;
export const UpdateThemeFieldInputFragmentDoc = gql `
    fragment UpdateThemeFieldInput on Theme {
  highlightColor
  darkColor
  defaultColor
  font
}
    `;
export const ChooseProductFragmentDoc = gql `
    fragment ChooseProduct on Product {
  ...ChooseSubscriptionScreenProduct
}
    ${ChooseSubscriptionScreenProductFragmentDoc}`;
export const UpdateVariantSelectFragmentDoc = gql `
    fragment UpdateVariantSelect on Fulfillment {
  variant {
    ...ChooseSubscriptionScreenVariant
  }
}
    ${ChooseSubscriptionScreenVariantFragmentDoc}`;
export const CurrentPlatformLineItemsFragmentDoc = gql `
    fragment CurrentPlatformLineItems on Fulfillment {
  platformLineItems {
    quantity
    platformProductVariantId
  }
}
    `;
export const FulfillmentAddressStateFragmentDoc = gql `
    fragment FulfillmentAddressState on Fulfillment {
  address {
    state
  }
}
    `;
export const FulfillmentAddressCountryFragmentDoc = gql `
    fragment FulfillmentAddressCountry on Fulfillment {
  address {
    country
  }
}
    `;
export const SaveMemberships2FragmentDoc = gql `
    fragment SaveMemberships2 on Business {
  membershipTiers(kind: Live) {
    id
    name
    defaultMode
    overridePlatformProductSync
    plans {
      kind
      price {
        amount
      }
    }
    discounts {
      scope
      percentage
      guests
    }
    welcomeGift {
      __typename
      id
      name
      products {
        id
        name
        platformId
        platformName
        platformVariantsOnlyMode
        variants {
          id
          description
          additionalCost {
            amount
          }
          platformName
          platformId
        }
      }
      variants {
        id
        description
        additionalCost {
          amount
        }
        platformName
        platformId
      }
    }
    benefits {
      __typename
      id
      name
      ... on SubscriptionBenefit {
        delivery
        nextShipmentDate
        isAddonOnly
        shippingFrequency {
          number
          period
        }
        deliveryFrequency
        firstShipmentDelay
        curationPreferOverstock
        curationMatchMode
        products {
          id
          name
          platformId
          platformName
          platformVariantsOnlyMode
          curationValue
          curationExcludeProducts
          curationCollections
          variants {
            id
            description
            additionalCost {
              amount
            }
            platformName
            platformId
            curationExcludeProducts
            curationIncludeVariants
            curationSearchTerms
            curationStatus
          }
        }
        variants {
          id
          description
          additionalCost {
            amount
          }
          platformName
          platformId
        }
        addons {
          id
          description
          applyDiscount
          dontRollOver
          platformId
          platformName
          additionalCost {
            amount
          }
        }
      }
    }
  }
}
    `;
export const ExperienceBlockFragmentDoc = gql `
    fragment ExperienceBlock on Business {
  launchPressedDate
  status
  membershipTiers {
    shopifyHandle
  }
  shopifyBadgeAppEmbedBlockPublished
  shopifyCartUpsellAppEmbedBlockPublished
  shopifyAppBlockPublished
  shopifyMemberExperienceAppEmbedBlockPublished
}
    `;
export const UpdateThemeFragmentDoc = gql `
    fragment UpdateTheme on Theme {
  cornerRoundness
  badgeText1
  badgeText2
  badgeAlignment
  badgeInverted
  badgeFontSize
}
    `;
export const ExperienceScreenUpdatePreferenceFragmentDoc = gql `
    fragment ExperienceScreenUpdatePreference on Business {
  enablePastCustomerUpsell
  enableEmailUpsell
  enableRedirectUpsell
  enableSmsUpsell
  enableTips
  enableFAQ
  enableBadge
  enableNavigationLink
  enableAddToCartUpsell
  enableSidebarUpsell
  theme {
    id
    ...UpdateTheme
  }
}
    ${UpdateThemeFragmentDoc}`;
export const ExperienceScreenPreferencesFragmentDoc = gql `
    fragment ExperienceScreenPreferences on Business {
  id
  alias
  name
  shopifyShop
  status
  shopifyVersion
  team {
    id
    code
  }
  ...ExperienceScreenUpdatePreference
}
    ${ExperienceScreenUpdatePreferenceFragmentDoc}`;
export const ExperienceScreenQueryFragmentDoc = gql `
    fragment ExperienceScreenQuery on Business {
  id
  launchPressedDate
  theme {
    id
  }
  ...ExperienceScreenPreferences
}
    ${ExperienceScreenPreferencesFragmentDoc}`;
export const FulfillmentLineAddressFragmentDoc = gql `
    fragment FulfillmentLineAddress on Address {
  shippingName
  line1
  line2
  city
  state
  zip
  country
}
    `;
export const FulfillmentLineAddonsFragmentDoc = gql `
    fragment FulfillmentLineAddons on Addon {
  id
  description
  platformId
}
    `;
export const FulfillmentLineFragmentDoc = gql `
    fragment FulfillmentLine on Fulfillment {
  id
  isFulfilled
  isArchived
  isGift
  deliveryMethod
  fulfillmentDate
  isReadyForPickup
  shopifyUrl
  platformIdKind
  extraCharge {
    amount
  }
  membership {
    tier {
      name
    }
    plan {
      price {
        amount
      }
    }
  }
  benefit {
    id
    name
    ... on SubscriptionBenefit {
      shippingIncluded
      deliveredToYour
      isAddonOnly
    }
  }
  address {
    ...FulfillmentLineAddress
  }
  shippingNotes
  addons {
    ...FulfillmentLineAddons
  }
  productSelections {
    variant {
      id
      description
      platformId
      platformName
    }
  }
  variant {
    id
    description
    platformId
    platformName
  }
}
    ${FulfillmentLineAddressFragmentDoc}
${FulfillmentLineAddonsFragmentDoc}`;
export const FulfillmentItemFragmentDoc = gql `
    fragment FulfillmentItem on Fulfillment {
  ...FulfillmentLine
  id
  platformId
  deliveryMethod
  membership {
    id
    activated
    ended
    user {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
    }
    tier {
      id
      name
    }
    pauseStartDate
    pauseEndDate
    isPastDue
  }
  benefit {
    __typename
    id
    variants {
      platformId
      platformName
    }
    products {
      platformId
      platformName
      variants {
        platformId
        platformName
      }
    }
  }
  tags
}
    ${FulfillmentLineFragmentDoc}`;
export const UpdateTierNameFragmentDoc = gql `
    fragment UpdateTierName on MembershipTier {
  name
}
    `;
export const NewMembershipFragmentDoc = gql `
    fragment NewMembership on MembershipTier {
  defaultMode
  plans {
    kind
    price {
      amount
    }
  }
}
    `;
export const GetUpdatedDiscountsFragmentDoc = gql `
    fragment GetUpdatedDiscounts on MembershipTier {
  discounts {
    scope
    percentage
  }
}
    `;
export const UpdateShippingIncludedFragmentDoc = gql `
    fragment UpdateShippingIncluded on SubscriptionBenefit {
  shippingIncluded
}
    `;
export const UpdateShippingWeightFragmentDoc = gql `
    fragment UpdateShippingWeight on SubscriptionBenefit {
  shippingWeight
}
    `;
export const EmbedCodeInstructionsFragmentDoc = gql `
    fragment EmbedCodeInstructions on Business {
  id
  alias
  name
  features {
    name
    completed
  }
}
    `;
export const PostLaunchInstructionsv1FragmentDoc = gql `
    fragment PostLaunchInstructionsv1 on Business {
  shopifyVersion
  alias
  stripeId
  ...EmbedCodeInstructions
}
    ${EmbedCodeInstructionsFragmentDoc}`;
export const PostLaunchInstructionsv2FragmentDoc = gql `
    fragment PostLaunchInstructionsv2 on Business {
  shopifyVersion
  name
  alias
  launchPressedDate
  status
  membershipTiers(kind: Live) {
    shopifyHandle
  }
  shopifyTosAccepted
  shopifyMembershipsCollectionId
  shopifyProductsPublished
  shopifyCollectionsPublished
  shopifyAppBlockPublished
  shopifyBadgeAppEmbedBlockPublished
  shopifyCartUpsellAppEmbedBlockPublished
  shopifyThemeVersion
  shopifyHasMultipleChannels
  shopifyMemberExperienceAppEmbedBlockPublished
  ...EmbedCodeInstructions
}
    ${EmbedCodeInstructionsFragmentDoc}`;
export const TitleBarBusinessFragmentDoc = gql `
    fragment TitleBarBusiness on Business {
  id
  alias
  name
  dashboardLink
  oneLiner
  mission
  shopifyVersion
  status
  theme {
    id
  }
  enableProductSwapping
  enableAutomatedCuration
  includeWelcomeGiftInFirstShipment
}
    `;
export const VariantFragmentFragmentDoc = gql `
    fragment VariantFragment on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
  curationExcludeProducts
  curationIncludeVariants
  curationSearchTerms
  curationStatus
}
    `;
export const AddonFragmentFragmentDoc = gql `
    fragment AddonFragment on Addon {
  id
  description
  applyDiscount
  dontRollOver
  platformId
  platformName
  additionalCost {
    amount
  }
}
    `;
export const BenefitFragmentFragmentDoc = gql `
    fragment BenefitFragment on Benefit {
  __typename
  id
  name
  membershipTiers {
    id
    name
  }
  ... on WelcomeGiftBenefit {
    products {
      id
      name
      platformId
      platformName
      platformVariantsOnlyMode
      variants {
        ...VariantFragment
      }
    }
    variants {
      ...VariantFragment
    }
    shopifyProductIds
    shippingNotesInstructions
    shippingEnabled
    pickupEnabled
    shippingCost {
      amount
    }
  }
  ... on SubscriptionBenefit {
    delivery
    isAddonOnly
    nextShipmentDate
    shippingFrequency {
      number
      period
    }
    deliveryFrequency
    firstShipmentDelay
    products {
      id
      name
      platformId
      platformName
      platformVariantsOnlyMode
      curationValue
      curationCollections
      curationExcludeProducts
      variants {
        ...VariantFragment
      }
    }
    variants {
      ...VariantFragment
    }
    addons {
      ...AddonFragment
    }
    shippingIncluded
    shippingWeight
    shippingNotesInstructions
    shopifyProductIds
    curationPreferOverstock
    curationMatchMode
    shippingEnabled
    pickupEnabled
    shippingCost {
      amount
    }
  }
}
    ${VariantFragmentFragmentDoc}
${AddonFragmentFragmentDoc}`;
export const MembershipTierFragmentFragmentDoc = gql `
    fragment MembershipTierFragment on MembershipTier {
  id
  name
  manualDiscountCode
  defaultMode
  overridePlatformProductSync
  plans {
    kind
    price {
      amount
    }
  }
  discounts {
    scope
    percentage
    guests
  }
  image {
    id
    url
    cdnPath
  }
  subscriptionBenefit {
    id
    name
    membershipTiers {
      id
      name
    }
    delivery
    deliveryFrequency
    shippingFrequency {
      number
      period
    }
    nextShipmentDate
    isAddonOnly
  }
  benefits {
    id
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
export const AllMembershipTiersFragmentDoc = gql `
    fragment AllMembershipTiers on Business {
  membershipTiers {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
export const BusinessFragmentFragmentDoc = gql `
    fragment BusinessFragment on Business {
  id
  name
  alias
  status
  oneLiner
  mission
  qualifierOrderValue
  qualifierCustomers
  shopifyShop
  shopifyVersion
  stripeId
  address {
    neighborhood
    city
    stateAbbreviated
  }
  coverPhoto {
    id
    url
    cdnPath
  }
  logo {
    id
    url
    cdnPath
  }
  platforms {
    name
    mode
    connected
  }
  features {
    name
    completed
  }
  membershipTiers(kind: Live) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
export const UpdateUserDocument = gql `
    mutation UpdateUser($id: ID!, $userInput: UserInput!) {
  userUpdate(id: $id, userInput: $userInput) {
    ...UpdateUser
  }
}
    ${UpdateUserFragmentDoc}`;
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUserDocument, options);
}
export const UpdateFulfillmentDocument = gql `
    mutation UpdateFulfillment($id: ID!, $variantInput: VariantInput, $addressInput: AddressInput, $addons: [AddonInput!]!, $shippingNotes: String, $platformLineItems: [PlatformLineItemInput!], $productSelections: [ProductSelectionInput!], $fulfillmentDate: String, $fulfillmentDateAdjustmentReason: String, $deliveryMethod: DeliveryMethod, $claimedAt: String) {
  fulfillmentUpdate(
    id: $id
    fulfillmentInput: {addons: $addons, address: $addressInput, variant: $variantInput, shippingNotes: $shippingNotes, productSelections: $productSelections, platformLineItems: $platformLineItems, fulfillmentDate: $fulfillmentDate, fulfillmentDateAdjustmentReason: $fulfillmentDateAdjustmentReason, deliveryMethod: $deliveryMethod, claimedAt: $claimedAt}
  ) {
    id
    deliveryMethod
    addons {
      ...ChooseSubscriptionScreenAddon
    }
    variant {
      ...ChooseSubscriptionScreenVariant
    }
    address {
      ...ChooseSubscriptionScreenAddress
    }
    productSelections {
      ...ChooseProductSelection
    }
    shippingNotes
    fulfillmentDate
    fulfillmentDateAdjustmentReason
  }
}
    ${ChooseSubscriptionScreenAddonFragmentDoc}
${ChooseSubscriptionScreenVariantFragmentDoc}
${ChooseSubscriptionScreenAddressFragmentDoc}
${ChooseProductSelectionFragmentDoc}`;
/**
 * __useUpdateFulfillmentMutation__
 *
 * To run a mutation, you first call `useUpdateFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFulfillmentMutation, { data, loading, error }] = useUpdateFulfillmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      variantInput: // value for 'variantInput'
 *      addressInput: // value for 'addressInput'
 *      addons: // value for 'addons'
 *      shippingNotes: // value for 'shippingNotes'
 *      platformLineItems: // value for 'platformLineItems'
 *      productSelections: // value for 'productSelections'
 *      fulfillmentDate: // value for 'fulfillmentDate'
 *      fulfillmentDateAdjustmentReason: // value for 'fulfillmentDateAdjustmentReason'
 *      deliveryMethod: // value for 'deliveryMethod'
 *      claimedAt: // value for 'claimedAt'
 *   },
 * });
 */
export function useUpdateFulfillmentMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateFulfillmentDocument, options);
}
export const MarkFulfillmentFulfilledDocument = gql `
    mutation MarkFulfillmentFulfilled($id: ID!, $sendNotification: Boolean) {
  fulfillmentMarkFulfilled(id: $id, sendNotification: $sendNotification) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useMarkFulfillmentFulfilledMutation__
 *
 * To run a mutation, you first call `useMarkFulfillmentFulfilledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFulfillmentFulfilledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFulfillmentFulfilledMutation, { data, loading, error }] = useMarkFulfillmentFulfilledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sendNotification: // value for 'sendNotification'
 *   },
 * });
 */
export function useMarkFulfillmentFulfilledMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkFulfillmentFulfilledDocument, options);
}
export const MarkFulfillmentReadyForPickupDocument = gql `
    mutation MarkFulfillmentReadyForPickup($id: ID!, $sendNotification: Boolean) {
  fulfillmentMarkReadyForPickup(id: $id, sendNotification: $sendNotification) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useMarkFulfillmentReadyForPickupMutation__
 *
 * To run a mutation, you first call `useMarkFulfillmentReadyForPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFulfillmentReadyForPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFulfillmentReadyForPickupMutation, { data, loading, error }] = useMarkFulfillmentReadyForPickupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sendNotification: // value for 'sendNotification'
 *   },
 * });
 */
export function useMarkFulfillmentReadyForPickupMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkFulfillmentReadyForPickupDocument, options);
}
export const ArchiveFulfillmentDocument = gql `
    mutation ArchiveFulfillment($id: ID!) {
  fulfillmentArchive(id: $id) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useArchiveFulfillmentMutation__
 *
 * To run a mutation, you first call `useArchiveFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFulfillmentMutation, { data, loading, error }] = useArchiveFulfillmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveFulfillmentMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ArchiveFulfillmentDocument, options);
}
export const MarkAllAsReadyForPickupDocument = gql `
    mutation MarkAllAsReadyForPickup($sendNotification: Boolean, $query: FulfillmentQuery!) {
  fulfillmentBatchMarkReadyForPickup(
    sendNotification: $sendNotification
    query: $query
  ) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useMarkAllAsReadyForPickupMutation__
 *
 * To run a mutation, you first call `useMarkAllAsReadyForPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsReadyForPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsReadyForPickupMutation, { data, loading, error }] = useMarkAllAsReadyForPickupMutation({
 *   variables: {
 *      sendNotification: // value for 'sendNotification'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMarkAllAsReadyForPickupMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkAllAsReadyForPickupDocument, options);
}
export const MarkAllAsFulfilledDocument = gql `
    mutation MarkAllAsFulfilled($sendNotification: Boolean, $query: FulfillmentQuery!) {
  fulfillmentBatchMarkFulfilled(
    sendNotification: $sendNotification
    query: $query
  ) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useMarkAllAsFulfilledMutation__
 *
 * To run a mutation, you first call `useMarkAllAsFulfilledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsFulfilledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsFulfilledMutation, { data, loading, error }] = useMarkAllAsFulfilledMutation({
 *   variables: {
 *      sendNotification: // value for 'sendNotification'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMarkAllAsFulfilledMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(MarkAllAsFulfilledDocument, options);
}
export const ArchiveAllDocument = gql `
    mutation ArchiveAll($query: FulfillmentQuery!) {
  fulfillmentBatchArchive(query: $query) {
    ...FulfillmentLine
  }
}
    ${FulfillmentLineFragmentDoc}`;
/**
 * __useArchiveAllMutation__
 *
 * To run a mutation, you first call `useArchiveAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAllMutation, { data, loading, error }] = useArchiveAllMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useArchiveAllMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ArchiveAllDocument, options);
}
export const DeleteMembershipTierDocument = gql `
    mutation DeleteMembershipTier($id: ID!) {
  membershipTierDestroy(id: $id) {
    ...DeleteMembershipTierBusiness
  }
}
    ${DeleteMembershipTierBusinessFragmentDoc}`;
/**
 * __useDeleteMembershipTierMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipTierMutation, { data, loading, error }] = useDeleteMembershipTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMembershipTierMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteMembershipTierDocument, options);
}
export const GetBenefitAllDocument = gql `
    query GetBenefitAll($id: ID!) {
  benefit(id: $id) {
    ... on SubscriptionBenefit {
      ...SubscriptionBenefitPreferNetwork
      ...SubscriptionBenefitPreferCache
    }
    ... on WelcomeGiftBenefit {
      ...WelcomeGiftBenefitPreferNetwork
      ...WelcomeGiftBenefitPreferCache
    }
    ... on DriveBenefit {
      ...DriveBenefitPreferNetwork
      ...DriveBenefitPreferCache
    }
  }
}
    ${SubscriptionBenefitPreferNetworkFragmentDoc}
${SubscriptionBenefitPreferCacheFragmentDoc}
${WelcomeGiftBenefitPreferNetworkFragmentDoc}
${WelcomeGiftBenefitPreferCacheFragmentDoc}
${DriveBenefitPreferNetworkFragmentDoc}
${DriveBenefitPreferCacheFragmentDoc}`;
/**
 * __useGetBenefitAllQuery__
 *
 * To run a query within a React component, call `useGetBenefitAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefitAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefitAllQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefitAllQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBenefitAllDocument, options);
}
export function useGetBenefitAllLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBenefitAllDocument, options);
}
export function useGetBenefitAllSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBenefitAllDocument, options);
}
export const GetBenefitPreferNetworkDocument = gql `
    query GetBenefitPreferNetwork($id: ID!) {
  benefit(id: $id) {
    ... on SubscriptionBenefit {
      ...SubscriptionBenefitPreferNetwork
    }
    ... on WelcomeGiftBenefit {
      ...WelcomeGiftBenefitPreferNetwork
    }
    ... on DriveBenefit {
      ...DriveBenefitPreferNetwork
    }
  }
}
    ${SubscriptionBenefitPreferNetworkFragmentDoc}
${WelcomeGiftBenefitPreferNetworkFragmentDoc}
${DriveBenefitPreferNetworkFragmentDoc}`;
/**
 * __useGetBenefitPreferNetworkQuery__
 *
 * To run a query within a React component, call `useGetBenefitPreferNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefitPreferNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefitPreferNetworkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefitPreferNetworkQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBenefitPreferNetworkDocument, options);
}
export function useGetBenefitPreferNetworkLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBenefitPreferNetworkDocument, options);
}
export function useGetBenefitPreferNetworkSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBenefitPreferNetworkDocument, options);
}
export const GetBenefitPreferCacheDocument = gql `
    query GetBenefitPreferCache($id: ID!) {
  benefit(id: $id) {
    ... on SubscriptionBenefit {
      ...SubscriptionBenefitPreferCache
    }
    ... on WelcomeGiftBenefit {
      ...WelcomeGiftBenefitPreferCache
    }
    ... on DriveBenefit {
      ...DriveBenefitPreferCache
    }
  }
}
    ${SubscriptionBenefitPreferCacheFragmentDoc}
${WelcomeGiftBenefitPreferCacheFragmentDoc}
${DriveBenefitPreferCacheFragmentDoc}`;
/**
 * __useGetBenefitPreferCacheQuery__
 *
 * To run a query within a React component, call `useGetBenefitPreferCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefitPreferCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefitPreferCacheQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefitPreferCacheQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBenefitPreferCacheDocument, options);
}
export function useGetBenefitPreferCacheLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBenefitPreferCacheDocument, options);
}
export function useGetBenefitPreferCacheSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBenefitPreferCacheDocument, options);
}
export const AdvancedScreenDocument = gql `
    query AdvancedScreen($id: ID!) {
  business(id: $id) {
    id
    dashboardLink
  }
}
    `;
/**
 * __useAdvancedScreenQuery__
 *
 * To run a query within a React component, call `useAdvancedScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvancedScreenQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(AdvancedScreenDocument, options);
}
export function useAdvancedScreenLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(AdvancedScreenDocument, options);
}
export function useAdvancedScreenSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(AdvancedScreenDocument, options);
}
export const GetAllRegularBenefitsDocument = gql `
    query GetAllRegularBenefits($tierId: ID!) {
  membershipTier(id: $tierId) {
    id
    business {
      id
      membershipTiers(kind: Live) {
        id
        benefits {
          id
          __typename
          ... on RegularBenefit {
            order
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetAllRegularBenefitsQuery__
 *
 * To run a query within a React component, call `useGetAllRegularBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRegularBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRegularBenefitsQuery({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useGetAllRegularBenefitsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAllRegularBenefitsDocument, options);
}
export function useGetAllRegularBenefitsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAllRegularBenefitsDocument, options);
}
export function useGetAllRegularBenefitsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetAllRegularBenefitsDocument, options);
}
export const SubscriptionBenefitComponentDocument = gql `
    query SubscriptionBenefitComponent($id: ID!) {
  benefit(id: $id) {
    __typename
    id
    name
    membershipTiers {
      id
      name
    }
    ... on SubscriptionBenefit {
      delivery
      nextShipmentDate
      deliveryFrequency
      shippingFrequency {
        __typename
        number
        period
      }
      curationPreferOverstock
      curationMatchMode
      products {
        id
        name
        platformId
        platformName
        platformVariantsOnlyMode
        curationCollections
        curationExcludeProducts
        variants {
          ...VariantFragment
        }
      }
      addons {
        ...AddonFragment
      }
      variants {
        ...VariantFragment
      }
      shopifyProductIds
      fulfillments {
        id
      }
    }
  }
}
    ${VariantFragmentFragmentDoc}
${AddonFragmentFragmentDoc}`;
/**
 * __useSubscriptionBenefitComponentQuery__
 *
 * To run a query within a React component, call `useSubscriptionBenefitComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionBenefitComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionBenefitComponentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionBenefitComponentQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SubscriptionBenefitComponentDocument, options);
}
export function useSubscriptionBenefitComponentLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SubscriptionBenefitComponentDocument, options);
}
export function useSubscriptionBenefitComponentSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(SubscriptionBenefitComponentDocument, options);
}
export const WelcomeGiftComponentDocument = gql `
    query WelcomeGiftComponent($id: ID!) {
  benefit(id: $id) {
    __typename
    id
    name
    membershipTiers {
      id
      name
    }
    ... on WelcomeGiftBenefit {
      products {
        id
        name
        platformId
        platformName
        platformVariantsOnlyMode
        variants {
          ...VariantFragment
        }
      }
      variants {
        ...VariantFragment
      }
      shopifyProductIds
    }
  }
}
    ${VariantFragmentFragmentDoc}`;
/**
 * __useWelcomeGiftComponentQuery__
 *
 * To run a query within a React component, call `useWelcomeGiftComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWelcomeGiftComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWelcomeGiftComponentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWelcomeGiftComponentQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(WelcomeGiftComponentDocument, options);
}
export function useWelcomeGiftComponentLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(WelcomeGiftComponentDocument, options);
}
export function useWelcomeGiftComponentSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(WelcomeGiftComponentDocument, options);
}
export const BrandScreenBusinessDocument = gql `
    query BrandScreenBusiness($id: ID!) {
  business(id: $id) {
    id
    alias
    status
    shopifyVersion
    theme {
      id
    }
  }
}
    `;
/**
 * __useBrandScreenBusinessQuery__
 *
 * To run a query within a React component, call `useBrandScreenBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandScreenBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandScreenBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandScreenBusinessQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BrandScreenBusinessDocument, options);
}
export function useBrandScreenBusinessLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BrandScreenBusinessDocument, options);
}
export function useBrandScreenBusinessSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BrandScreenBusinessDocument, options);
}
export const UpdateThemeDocument = gql `
    mutation UpdateTheme($businessId: ID!, $theme: ThemeInput!) {
  updateTheme(businessId: $businessId, themeInput: $theme) {
    theme {
      ...UpdateThemeFieldInput
    }
  }
}
    ${UpdateThemeFieldInputFragmentDoc}`;
/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateThemeDocument, options);
}
export const UpdateBrandV1Document = gql `
    mutation UpdateBrandV1($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...UpdateBrandFragmentV1
  }
}
    ${UpdateBrandFragmentV1FragmentDoc}`;
/**
 * __useUpdateBrandV1Mutation__
 *
 * To run a mutation, you first call `useUpdateBrandV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandV1Mutation, { data, loading, error }] = useUpdateBrandV1Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useUpdateBrandV1Mutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBrandV1Document, options);
}
export const UpdateBrandV2Document = gql `
    mutation UpdateBrandV2($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...UpdateBrandFragmentV2
  }
}
    ${UpdateBrandFragmentV2FragmentDoc}`;
/**
 * __useUpdateBrandV2Mutation__
 *
 * To run a mutation, you first call `useUpdateBrandV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandV2Mutation, { data, loading, error }] = useUpdateBrandV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useUpdateBrandV2Mutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBrandV2Document, options);
}
export const BrandScreenInnerDocument = gql `
    query BrandScreenInner($id: ID!) {
  business(id: $id) {
    id
    alias
    status
    name
    address {
      neighborhood
      city
      stateAbbreviated
    }
    coverPhoto {
      id
      cdnPath
    }
    logo {
      id
      cdnPath
    }
    theme {
      id
      ...UpdateThemeFieldInput
    }
    ...UpdateBusinessFieldInput
    ...UpdateBusiness
    ...ExperienceScreenPreferences
  }
}
    ${UpdateThemeFieldInputFragmentDoc}
${UpdateBusinessFieldInputFragmentDoc}
${UpdateBusinessFragmentDoc}
${ExperienceScreenPreferencesFragmentDoc}`;
/**
 * __useBrandScreenInnerQuery__
 *
 * To run a query within a React component, call `useBrandScreenInnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandScreenInnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandScreenInnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandScreenInnerQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BrandScreenInnerDocument, options);
}
export function useBrandScreenInnerLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BrandScreenInnerDocument, options);
}
export function useBrandScreenInnerSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BrandScreenInnerDocument, options);
}
export const ChooseSubscriptionScreenDocument = gql `
    query ChooseSubscriptionScreen($id: ID!) {
  fulfillment(id: $id) {
    claimedAt
    id
    fulfillmentDate
    fulfillmentDateAdjustmentReason
    deliveryMethod
    variant {
      ...ChooseSubscriptionScreenVariant
    }
    productSelections {
      ...ChooseProductSelection
    }
    membership {
      id
      unfulfilledFulfillments: fulfillments(query: {isFulfilled: false}) {
        fulfillmentDate
        id
        benefit {
          id
        }
        address {
          ...ChooseSubscriptionScreenAddress
        }
        variant {
          ...ChooseSubscriptionScreenVariant
        }
        addons {
          ...ChooseSubscriptionScreenAddon
        }
        productSelections {
          ...ChooseProductSelection
        }
        shippingNotes
      }
      user {
        id
        firstName
        lastName
        phoneNumber
      }
      purchaser {
        id
        firstName
        lastName
      }
      tier {
        id
        name
        discounts {
          scope
          percentage
        }
        subscriptionBenefit {
          shippingIncluded
        }
      }
    }
    addons {
      ...ChooseSubscriptionScreenAddon
    }
    shippingNotes
    address {
      ...ChooseSubscriptionScreenAddress
    }
    isGift
    benefit {
      __typename
      id
      name
      ... on SubscriptionBenefit {
        isAddonOnly
        deliveredToYour
        shippingCost {
          amount
        }
        pickupEnabled
        shippingEnabled
        shippingIncluded
        shippingNotesInstructions
        shippingFrequency {
          period
        }
        deliveryFrequency
        delivery
        membershipTiers {
          members(status: Active) {
            id
          }
          plans {
            kind
            price {
              amount
            }
          }
        }
        business {
          id
          shopifyVersion
          enableProductSwapping
        }
        claimable
      }
      ... on DriveBenefit {
        deliveredToYour
        shippingNotesInstructions
        shippingCost {
          amount
        }
        pickupEnabled
        shippingEnabled
        claimable
        business {
          id
          shopifyVersion
        }
      }
      ... on WelcomeGiftBenefit {
        deliveredToYour
        shippingNotesInstructions
        shippingCost {
          amount
        }
        pickupEnabled
        shippingEnabled
        claimable
        business {
          id
          shopifyVersion
        }
      }
      products {
        ...ChooseSubscriptionScreenProduct
      }
      variants {
        ...ChooseSubscriptionScreenVariant
      }
      addons {
        id
        description
        additionalCost {
          amount
        }
        applyDiscount
        platformId
        platformName
      }
    }
    defaultCurations {
      productSelections {
        product {
          id
        }
        variant {
          id
        }
      }
      platformLineItems {
        quantity
        platformProductVariantId
      }
    }
    platformLineItems {
      quantity
      platformProductVariantId
      swapped
    }
    curated
  }
}
    ${ChooseSubscriptionScreenVariantFragmentDoc}
${ChooseProductSelectionFragmentDoc}
${ChooseSubscriptionScreenAddressFragmentDoc}
${ChooseSubscriptionScreenAddonFragmentDoc}
${ChooseSubscriptionScreenProductFragmentDoc}`;
/**
 * __useChooseSubscriptionScreenQuery__
 *
 * To run a query within a React component, call `useChooseSubscriptionScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseSubscriptionScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseSubscriptionScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChooseSubscriptionScreenQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ChooseSubscriptionScreenDocument, options);
}
export function useChooseSubscriptionScreenLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ChooseSubscriptionScreenDocument, options);
}
export function useChooseSubscriptionScreenSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ChooseSubscriptionScreenDocument, options);
}
export const ChooseYourFighterDocument = gql `
    query ChooseYourFighter($id: ID!) {
  business(id: $id) {
    id
    status
    shopifyVersion
    membershipTiers(kind: Live) {
      id
      defaultMode
      plans {
        kind
        price {
          amount
        }
      }
      discounts {
        scope
        percentage
        guests
      }
    }
  }
}
    `;
/**
 * __useChooseYourFighterQuery__
 *
 * To run a query within a React component, call `useChooseYourFighterQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseYourFighterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseYourFighterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChooseYourFighterQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ChooseYourFighterDocument, options);
}
export function useChooseYourFighterLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ChooseYourFighterDocument, options);
}
export function useChooseYourFighterSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ChooseYourFighterDocument, options);
}
export const CollectionNamesDocument = gql `
    query CollectionNames($id: ID!) {
  business(id: $id) {
    id
    shopifyCollectionNames
  }
}
    `;
/**
 * __useCollectionNamesQuery__
 *
 * To run a query within a React component, call `useCollectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionNamesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionNamesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CollectionNamesDocument, options);
}
export function useCollectionNamesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CollectionNamesDocument, options);
}
export function useCollectionNamesSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CollectionNamesDocument, options);
}
export const PollCreateAccountJobDocument = gql `
    query PollCreateAccountJob($id: ID!) {
  jobFinished(id: $id)
}
    `;
/**
 * __usePollCreateAccountJobQuery__
 *
 * To run a query within a React component, call `usePollCreateAccountJobQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollCreateAccountJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollCreateAccountJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePollCreateAccountJobQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PollCreateAccountJobDocument, options);
}
export function usePollCreateAccountJobLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PollCreateAccountJobDocument, options);
}
export function usePollCreateAccountJobSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(PollCreateAccountJobDocument, options);
}
export const PollImportCompletedDocument = gql `
    query PollImportCompleted($id: ID!) {
  business(id: $id) {
    id
    importAnalytics {
      averageOrderValue {
        amount
      }
      customerVisitFrequency
    }
  }
}
    `;
/**
 * __usePollImportCompletedQuery__
 *
 * To run a query within a React component, call `usePollImportCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollImportCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollImportCompletedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePollImportCompletedQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PollImportCompletedDocument, options);
}
export function usePollImportCompletedLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PollImportCompletedDocument, options);
}
export function usePollImportCompletedSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(PollImportCompletedDocument, options);
}
export const BenefitMembershipTierInfoDocument = gql `
    query BenefitMembershipTierInfo($id: ID!) {
  benefit(id: $id) {
    ... on SubscriptionBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
    }
    ... on WelcomeGiftBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useBenefitMembershipTierInfoQuery__
 *
 * To run a query within a React component, call `useBenefitMembershipTierInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitMembershipTierInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitMembershipTierInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBenefitMembershipTierInfoQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BenefitMembershipTierInfoDocument, options);
}
export function useBenefitMembershipTierInfoLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BenefitMembershipTierInfoDocument, options);
}
export function useBenefitMembershipTierInfoSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BenefitMembershipTierInfoDocument, options);
}
export const ExperienceScreenQueryV1Document = gql `
    query ExperienceScreenQueryV1($id: ID!) {
  business(id: $id) {
    ...ExperienceScreenQuery
  }
}
    ${ExperienceScreenQueryFragmentDoc}`;
/**
 * __useExperienceScreenQueryV1Query__
 *
 * To run a query within a React component, call `useExperienceScreenQueryV1Query` and pass it any options that fit your needs.
 * When your component renders, `useExperienceScreenQueryV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceScreenQueryV1Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperienceScreenQueryV1Query(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ExperienceScreenQueryV1Document, options);
}
export function useExperienceScreenQueryV1LazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ExperienceScreenQueryV1Document, options);
}
export function useExperienceScreenQueryV1SuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ExperienceScreenQueryV1Document, options);
}
export const ExperienceScreenQueryV2Document = gql `
    query ExperienceScreenQueryV2($id: ID!) {
  business(id: $id) {
    ...ExperienceScreenQuery
    membershipTiers {
      shopifyHandle
    }
    shopifyMemberExperienceAppEmbedBlockPublished
    shopifyBadgeAppEmbedBlockPublished
    shopifyCartUpsellAppEmbedBlockPublished
    shopifyAppBlockPublished
  }
}
    ${ExperienceScreenQueryFragmentDoc}`;
/**
 * __useExperienceScreenQueryV2Query__
 *
 * To run a query within a React component, call `useExperienceScreenQueryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useExperienceScreenQueryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperienceScreenQueryV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperienceScreenQueryV2Query(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ExperienceScreenQueryV2Document, options);
}
export function useExperienceScreenQueryV2LazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ExperienceScreenQueryV2Document, options);
}
export function useExperienceScreenQueryV2SuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ExperienceScreenQueryV2Document, options);
}
export const ExportShippingLabelsScreenDocument = gql `
    query ExportShippingLabelsScreen($first: Int!, $after: String, $query: FulfillmentQuery!, $businessId: ID!) {
  business(id: $businessId) {
    id
    name
  }
  fulfillments(first: $first, after: $after, query: $query) {
    edges {
      node {
        ...FulfillmentItem
      }
    }
    pageInfo {
      endCursor
    }
  }
}
    ${FulfillmentItemFragmentDoc}`;
/**
 * __useExportShippingLabelsScreenQuery__
 *
 * To run a query within a React component, call `useExportShippingLabelsScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportShippingLabelsScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportShippingLabelsScreenQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useExportShippingLabelsScreenQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ExportShippingLabelsScreenDocument, options);
}
export function useExportShippingLabelsScreenLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ExportShippingLabelsScreenDocument, options);
}
export function useExportShippingLabelsScreenSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ExportShippingLabelsScreenDocument, options);
}
export const FulfillmentDownloadCsvDocument = gql `
    query FulfillmentDownloadCSV($first: Int!, $after: String, $query: FulfillmentQuery!) {
  fulfillments(first: $first, after: $after, query: $query) {
    edges {
      node {
        ...FulfillmentItem
        tags
      }
    }
    pageInfo {
      endCursor
    }
  }
}
    ${FulfillmentItemFragmentDoc}`;
/**
 * __useFulfillmentDownloadCsvQuery__
 *
 * To run a query within a React component, call `useFulfillmentDownloadCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentDownloadCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentDownloadCsvQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFulfillmentDownloadCsvQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FulfillmentDownloadCsvDocument, options);
}
export function useFulfillmentDownloadCsvLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FulfillmentDownloadCsvDocument, options);
}
export function useFulfillmentDownloadCsvSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(FulfillmentDownloadCsvDocument, options);
}
export const FulfillmentScreenDocument = gql `
    query FulfillmentScreen($first: Int, $after: String, $query: FulfillmentQuery!, $businessId: ID!) {
  business(id: $businessId) {
    id
    shopifyToken
    shopifyShop
    shopifyVersion
    membershipTiers {
      id
      name
    }
  }
  fulfillments(first: $first, after: $after, query: $query) {
    edges {
      node {
        ...FulfillmentItem
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FulfillmentItemFragmentDoc}`;
/**
 * __useFulfillmentScreenQuery__
 *
 * To run a query within a React component, call `useFulfillmentScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentScreenQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useFulfillmentScreenQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FulfillmentScreenDocument, options);
}
export function useFulfillmentScreenLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FulfillmentScreenDocument, options);
}
export function useFulfillmentScreenSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(FulfillmentScreenDocument, options);
}
export const LaunchScreenv1Document = gql `
    query LaunchScreenv1($id: ID!) {
  business(id: $id) {
    id
    alias
    created
    name
    status
    shopifyShop
    shopifyVersion
    segment
    ...PostLaunchInstructionsv1
  }
}
    ${PostLaunchInstructionsv1FragmentDoc}`;
/**
 * __useLaunchScreenv1Query__
 *
 * To run a query within a React component, call `useLaunchScreenv1Query` and pass it any options that fit your needs.
 * When your component renders, `useLaunchScreenv1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchScreenv1Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchScreenv1Query(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(LaunchScreenv1Document, options);
}
export function useLaunchScreenv1LazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(LaunchScreenv1Document, options);
}
export function useLaunchScreenv1SuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(LaunchScreenv1Document, options);
}
export const LaunchScreenv2Document = gql `
    query LaunchScreenv2($id: ID!) {
  business(id: $id) {
    shopifyTosAccepted
    shopifyPricingTerms
    ...PostLaunchInstructionsv2
  }
}
    ${PostLaunchInstructionsv2FragmentDoc}`;
/**
 * __useLaunchScreenv2Query__
 *
 * To run a query within a React component, call `useLaunchScreenv2Query` and pass it any options that fit your needs.
 * When your component renders, `useLaunchScreenv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchScreenv2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchScreenv2Query(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(LaunchScreenv2Document, options);
}
export function useLaunchScreenv2LazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(LaunchScreenv2Document, options);
}
export function useLaunchScreenv2SuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(LaunchScreenv2Document, options);
}
export const VerifyStripeAccountDocument = gql `
    mutation VerifyStripeAccount($id: ID!, $country: String) {
  verifyStripeAccount(id: $id, country: $country)
}
    `;
/**
 * __useVerifyStripeAccountMutation__
 *
 * To run a mutation, you first call `useVerifyStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyStripeAccountMutation, { data, loading, error }] = useVerifyStripeAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useVerifyStripeAccountMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(VerifyStripeAccountDocument, options);
}
export const CreateAppSubscriptionDocument = gql `
    mutation CreateAppSubscription($shopifyShop: String!) {
  createAppSubscriptionShopify(shopifyShop: $shopifyShop)
}
    `;
/**
 * __useCreateAppSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAppSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppSubscriptionMutation, { data, loading, error }] = useCreateAppSubscriptionMutation({
 *   variables: {
 *      shopifyShop: // value for 'shopifyShop'
 *   },
 * });
 */
export function useCreateAppSubscriptionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateAppSubscriptionDocument, options);
}
export const MembershipLevelComponentDocument = gql `
    query MembershipLevelComponent($id: ID!) {
  membershipTier(id: $id) {
    id
    name
    manualDiscountCode
    defaultMode
    overridePlatformProductSync
    members {
      id
    }
    business {
      id
      status
      membershipTiers(kind: Live) {
        id
        name
        benefits {
          id
        }
        subscriptionBenefit {
          id
          delivery
          deliveryFrequency
          shippingFrequency {
            number
            period
          }
          firstShipmentDelay
          shippingIncluded
          nextShipmentDate
        }
      }
    }
    plans {
      kind
      price {
        amount
      }
    }
    discounts {
      scope
      percentage
      guests
    }
    image {
      id
      url
      cdnPath
    }
    welcomeGift {
      __typename
      id
      name
      shippingNotesInstructions
      membershipTiers {
        id
        name
      }
      products {
        ...SubscriptionBenefitProduct
      }
      variants {
        ...VariantPanel
      }
      delivery
      shippingEnabled
      pickupEnabled
      shippingCost {
        amount
      }
      shopifyProductIds
    }
    subscriptionBenefit {
      id
      name
      membershipTiers {
        id
        name
        members(status: Active) {
          id
        }
        plan(kind: MONTHLY) {
          price {
            amount
          }
        }
      }
      delivery
      deliveryFrequency
      shippingFrequency {
        __typename
        number
        period
      }
      firstShipmentDelay
      nextShipmentDate
      isAddonOnly
      products {
        ...SubscriptionBenefitProduct
      }
      variants {
        ...VariantPanel
      }
      addons {
        ...AddonPanel
      }
      shopifyProductIds
      shippingIncluded
      shippingWeight
      shippingNotesInstructions
      curationPreferOverstock
      curationMatchMode
      shippingEnabled
      pickupEnabled
      shippingCost {
        amount
      }
    }
    benefits {
      __typename
      id
      name
      membershipTiers {
        id
        name
        members(status: Active) {
          id
        }
        plan(kind: MONTHLY) {
          price {
            amount
          }
        }
      }
      ... on RegularBenefit {
        order
      }
      ... on WelcomeGiftBenefit {
        delivery
        shopifyProductIds
      }
      ... on SubscriptionBenefit {
        delivery
        deliveryFrequency
        shippingFrequency {
          __typename
          number
          period
        }
        firstShipmentDelay
        nextShipmentDate
        shopifyProductIds
        shippingIncluded
        shippingWeight
        shippingNotesInstructions
        curationPreferOverstock
        curationMatchMode
        shippingEnabled
        pickupEnabled
        shippingCost {
          amount
        }
        isAddonOnly
        products {
          ...SubscriptionBenefitProduct
        }
        variants {
          ...VariantPanel
        }
        addons {
          ...AddonPanel
        }
      }
    }
  }
}
    ${SubscriptionBenefitProductFragmentDoc}
${VariantPanelFragmentDoc}
${AddonPanelFragmentDoc}`;
/**
 * __useMembershipLevelComponentQuery__
 *
 * To run a query within a React component, call `useMembershipLevelComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipLevelComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipLevelComponentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipLevelComponentQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipLevelComponentDocument, options);
}
export function useMembershipLevelComponentLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipLevelComponentDocument, options);
}
export function useMembershipLevelComponentSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipLevelComponentDocument, options);
}
export const MembershipsCustomerAnalyticsReportDocument = gql `
    query MembershipsCustomerAnalyticsReport($id: ID!) {
  business(id: $id) {
    id
    importAnalytics {
      averageOrderValue {
        amount
      }
      customerVisitFrequency
    }
  }
}
    `;
/**
 * __useMembershipsCustomerAnalyticsReportQuery__
 *
 * To run a query within a React component, call `useMembershipsCustomerAnalyticsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipsCustomerAnalyticsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipsCustomerAnalyticsReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipsCustomerAnalyticsReportQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipsCustomerAnalyticsReportDocument, options);
}
export function useMembershipsCustomerAnalyticsReportLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipsCustomerAnalyticsReportDocument, options);
}
export function useMembershipsCustomerAnalyticsReportSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipsCustomerAnalyticsReportDocument, options);
}
export const BusinessMembershipTiersDocument = gql `
    query BusinessMembershipTiers($id: ID!) {
  business(id: $id) {
    id
    dashboardUrl
    status
    membershipTiers(kind: Live) {
      defaultMode
      id
      name
    }
  }
}
    `;
/**
 * __useBusinessMembershipTiersQuery__
 *
 * To run a query within a React component, call `useBusinessMembershipTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessMembershipTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessMembershipTiersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessMembershipTiersQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BusinessMembershipTiersDocument, options);
}
export function useBusinessMembershipTiersLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BusinessMembershipTiersDocument, options);
}
export function useBusinessMembershipTiersSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BusinessMembershipTiersDocument, options);
}
export const ReportsScreenDocument = gql `
    query ReportsScreen($businessId: ID!, $reports: [String]!) {
  business(id: $businessId) {
    id
    alias
    name
    currencyCode
    team {
      emailAddress
      code
    }
    members {
      id
      status
      activated
      cancelled
      ended
      isPastDue
      cancellationReason
      cancellationReasonNote
      upsellSource
      user {
        firstName
        lastName
        emailAddress
      }
      plan {
        kind
        price {
          amount
        }
      }
    }
    reports(reports: $reports) {
      ... on GrowthReport {
        title
        growthReportDates {
          date
          gmvGrowth {
            amount
          }
          gmvInvoluntaryChurn {
            amount
          }
          gmvVoluntaryChurn {
            amount
          }
          memberGrowth
          memberInvoluntaryChurn
          memberVoluntaryChurn
        }
      }
    }
  }
}
    `;
/**
 * __useReportsScreenQuery__
 *
 * To run a query within a React component, call `useReportsScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsScreenQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      reports: // value for 'reports'
 *   },
 * });
 */
export function useReportsScreenQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportsScreenDocument, options);
}
export function useReportsScreenLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportsScreenDocument, options);
}
export function useReportsScreenSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ReportsScreenDocument, options);
}
export const CampaignVideoDocument = gql `
    query CampaignVideo($id: ID!) {
  business(id: $id) {
    video {
      id
    }
    picture {
      id
      cdnPath
      url
    }
  }
}
    `;
/**
 * __useCampaignVideoQuery__
 *
 * To run a query within a React component, call `useCampaignVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignVideoQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CampaignVideoDocument, options);
}
export function useCampaignVideoLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CampaignVideoDocument, options);
}
export function useCampaignVideoSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CampaignVideoDocument, options);
}
export const UpdateCampaignPictureDocument = gql `
    mutation UpdateCampaignPicture($id: ID!, $imageInput: ImageInput!) {
  updateCampaignPicture(businessId: $id, imageInput: $imageInput) {
    picture {
      id
    }
  }
}
    `;
/**
 * __useUpdateCampaignPictureMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignPictureMutation, { data, loading, error }] = useUpdateCampaignPictureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateCampaignPictureMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateCampaignPictureDocument, options);
}
export const RemoveCampaignPictureDocument = gql `
    mutation RemoveCampaignPicture($id: ID!) {
  removeCampaignPicture(businessId: $id) {
    picture {
      id
    }
  }
}
    `;
/**
 * __useRemoveCampaignPictureMutation__
 *
 * To run a mutation, you first call `useRemoveCampaignPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCampaignPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCampaignPictureMutation, { data, loading, error }] = useRemoveCampaignPictureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCampaignPictureMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemoveCampaignPictureDocument, options);
}
export const UpdateCampaignVideoDocument = gql `
    mutation UpdateCampaignVideo($id: ID!, $videoInput: VideoInput!) {
  updateCampaignVideo(businessId: $id, videoInput: $videoInput) {
    video {
      id
    }
  }
}
    `;
/**
 * __useUpdateCampaignVideoMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignVideoMutation, { data, loading, error }] = useUpdateCampaignVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      videoInput: // value for 'videoInput'
 *   },
 * });
 */
export function useUpdateCampaignVideoMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateCampaignVideoDocument, options);
}
export const GetProductVariantsDocument = gql `
    query GetProductVariants($id: ID!) {
  business(id: $id) {
    id
    shopifyProductsCount
    shopifyProductVariants {
      id
      displayName
      price
      inventory
      inventoryTracked
      productId
      productType
      vendor
      tags
      createdAt
      collections
      productTitle
      variantTitle
      description
      imageUrl
      onlineStoreUrl
      sku
    }
  }
}
    `;
/**
 * __useGetProductVariantsQuery__
 *
 * To run a query within a React component, call `useGetProductVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductVariantsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetProductVariantsDocument, options);
}
export function useGetProductVariantsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetProductVariantsDocument, options);
}
export function useGetProductVariantsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetProductVariantsDocument, options);
}
export const WithfriendsTitleBarBusiness2Document = gql `
    query WithfriendsTitleBarBusiness2($id: ID!) {
  business(id: $id) {
    shopifyTosAccepted
    shopifyProductsPublished
    shopifyCollectionsPublished
    shopifyThemeVersion
    shopifyAppBlockPublished
  }
}
    `;
/**
 * __useWithfriendsTitleBarBusiness2Query__
 *
 * To run a query within a React component, call `useWithfriendsTitleBarBusiness2Query` and pass it any options that fit your needs.
 * When your component renders, `useWithfriendsTitleBarBusiness2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithfriendsTitleBarBusiness2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithfriendsTitleBarBusiness2Query(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(WithfriendsTitleBarBusiness2Document, options);
}
export function useWithfriendsTitleBarBusiness2LazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(WithfriendsTitleBarBusiness2Document, options);
}
export function useWithfriendsTitleBarBusiness2SuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(WithfriendsTitleBarBusiness2Document, options);
}
export const WithfriendsTitleBarBusinessDocument = gql `
    query WithfriendsTitleBarBusiness($id: ID!) {
  business(id: $id) {
    id
    membershipTiers(kind: Live) {
      id
      name
      defaultMode
      overridePlatformProductSync
      plans {
        kind
        price {
          amount
        }
      }
      discounts {
        scope
        percentage
        guests
      }
      benefits {
        __typename
        id
        name
        ... on SubscriptionBenefit {
          delivery
          nextShipmentDate
          isAddonOnly
          shippingFrequency {
            number
            period
          }
          deliveryFrequency
          firstShipmentDelay
          variants {
            id
            description
            additionalCost {
              amount
            }
            platformName
            platformId
          }
          addons {
            id
            description
            applyDiscount
            dontRollOver
            platformId
            platformName
            additionalCost {
              amount
            }
          }
        }
      }
    }
    ...TitleBarBusiness
  }
}
    ${TitleBarBusinessFragmentDoc}`;
/**
 * __useWithfriendsTitleBarBusinessQuery__
 *
 * To run a query within a React component, call `useWithfriendsTitleBarBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithfriendsTitleBarBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithfriendsTitleBarBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithfriendsTitleBarBusinessQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(WithfriendsTitleBarBusinessDocument, options);
}
export function useWithfriendsTitleBarBusinessLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(WithfriendsTitleBarBusinessDocument, options);
}
export function useWithfriendsTitleBarBusinessSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(WithfriendsTitleBarBusinessDocument, options);
}
export const WithfriendsTitleBarUpdateBusinessDocument = gql `
    mutation WithfriendsTitleBarUpdateBusiness($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...TitleBarBusiness
  }
}
    ${TitleBarBusinessFragmentDoc}`;
/**
 * __useWithfriendsTitleBarUpdateBusinessMutation__
 *
 * To run a mutation, you first call `useWithfriendsTitleBarUpdateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithfriendsTitleBarUpdateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withfriendsTitleBarUpdateBusinessMutation, { data, loading, error }] = useWithfriendsTitleBarUpdateBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useWithfriendsTitleBarUpdateBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(WithfriendsTitleBarUpdateBusinessDocument, options);
}
export const WithfriendsTitleBarLaunchBusinessDocument = gql `
    mutation WithfriendsTitleBarLaunchBusiness($id: ID!) {
  launchBusiness(id: $id) {
    success
    error
    message
  }
}
    `;
/**
 * __useWithfriendsTitleBarLaunchBusinessMutation__
 *
 * To run a mutation, you first call `useWithfriendsTitleBarLaunchBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithfriendsTitleBarLaunchBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withfriendsTitleBarLaunchBusinessMutation, { data, loading, error }] = useWithfriendsTitleBarLaunchBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWithfriendsTitleBarLaunchBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(WithfriendsTitleBarLaunchBusinessDocument, options);
}
export const BenefitDocument = gql `
    query Benefit($id: ID!) {
  benefit(id: $id) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useBenefitQuery__
 *
 * To run a query within a React component, call `useBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBenefitQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BenefitDocument, options);
}
export function useBenefitLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BenefitDocument, options);
}
export function useBenefitSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BenefitDocument, options);
}
export const BusinessDocument = gql `
    query Business($id: ID!) {
  business(id: $id) {
    ...BusinessFragment
  }
}
    ${BusinessFragmentFragmentDoc}`;
/**
 * __useBusinessQuery__
 *
 * To run a query within a React component, call `useBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BusinessDocument, options);
}
export function useBusinessLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BusinessDocument, options);
}
export function useBusinessSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BusinessDocument, options);
}
export const CreateBlankSimpleBenefitDocument = gql `
    mutation CreateBlankSimpleBenefit($membershipTierId: ID!, $name: String!) {
  addBenefit(
    membershipTierId: $membershipTierId
    benefit: {regular: {name: $name}}
  ) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useCreateBlankSimpleBenefitMutation__
 *
 * To run a mutation, you first call `useCreateBlankSimpleBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankSimpleBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankSimpleBenefitMutation, { data, loading, error }] = useCreateBlankSimpleBenefitMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateBlankSimpleBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateBlankSimpleBenefitDocument, options);
}
export const CreateBlankSubscriptionBenefitDocument = gql `
    mutation CreateBlankSubscriptionBenefit($membershipTierId: ID!, $name: String!, $productId: ID!, $variantId: ID!, $productName: String!, $delivery: DeliveryStrategy!, $deliveryFrequency: Int!, $shippingFrequency: DurationInput!, $firstShipmentDelay: Int!, $nextShipmentDate: String!, $shippingIncluded: Boolean!) {
  addBenefit(
    membershipTierId: $membershipTierId
    benefit: {subscription: {shippingIncluded: $shippingIncluded, name: $name, delivery: $delivery, curationMatchMode: PRODUCT, curationPreferOverstock: false, deliveryFrequency: $deliveryFrequency, shippingFrequency: $shippingFrequency, firstShipmentDelay: $firstShipmentDelay, nextShipmentDate: $nextShipmentDate, products: [{id: $productId, name: $productName, variants: [{id: $variantId, description: "Standard", additionalCost: {amount: 0}, curationStatus: APPROVED}]}], shippingEnabled: true, pickupEnabled: false, shippingCost: {amount: 0}}}
  ) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useCreateBlankSubscriptionBenefitMutation__
 *
 * To run a mutation, you first call `useCreateBlankSubscriptionBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankSubscriptionBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankSubscriptionBenefitMutation, { data, loading, error }] = useCreateBlankSubscriptionBenefitMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      name: // value for 'name'
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *      productName: // value for 'productName'
 *      delivery: // value for 'delivery'
 *      deliveryFrequency: // value for 'deliveryFrequency'
 *      shippingFrequency: // value for 'shippingFrequency'
 *      firstShipmentDelay: // value for 'firstShipmentDelay'
 *      nextShipmentDate: // value for 'nextShipmentDate'
 *      shippingIncluded: // value for 'shippingIncluded'
 *   },
 * });
 */
export function useCreateBlankSubscriptionBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateBlankSubscriptionBenefitDocument, options);
}
export const CreateBlankWelcomeGiftDocument = gql `
    mutation CreateBlankWelcomeGift($membershipTierId: ID!, $name: String!, $productId: ID!, $variantId: ID!, $productName: String!) {
  addBenefit(
    membershipTierId: $membershipTierId
    benefit: {welcomeGift: {addons: null, name: $name, products: [{id: $productId, name: $productName, variants: [{id: $variantId, description: "Standard", additionalCost: {amount: 0}}]}], delivery: IMMEDIATELY, shippingEnabled: true, pickupEnabled: false, shippingCost: {amount: 0}}}
  ) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useCreateBlankWelcomeGiftMutation__
 *
 * To run a mutation, you first call `useCreateBlankWelcomeGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankWelcomeGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankWelcomeGiftMutation, { data, loading, error }] = useCreateBlankWelcomeGiftMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      name: // value for 'name'
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useCreateBlankWelcomeGiftMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateBlankWelcomeGiftDocument, options);
}
export const CustomerAnalyticsReportDocument = gql `
    query CustomerAnalyticsReport($id: ID!) {
  business(id: $id) {
    id
    importAnalytics {
      title
      averageOrderValue {
        amount
      }
      customerVisitFrequency
      customerData {
        totalCustomers
      }
      orderData {
        totalOrders
      }
    }
  }
}
    `;
/**
 * __useCustomerAnalyticsReportQuery__
 *
 * To run a query within a React component, call `useCustomerAnalyticsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAnalyticsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAnalyticsReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerAnalyticsReportQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CustomerAnalyticsReportDocument, options);
}
export function useCustomerAnalyticsReportLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CustomerAnalyticsReportDocument, options);
}
export function useCustomerAnalyticsReportSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CustomerAnalyticsReportDocument, options);
}
export const DestroySubscriptionBenefitDocument = gql `
    mutation DestroySubscriptionBenefit($id: ID!) {
  destroyBenefit(id: $id) {
    ok
  }
}
    `;
/**
 * __useDestroySubscriptionBenefitMutation__
 *
 * To run a mutation, you first call `useDestroySubscriptionBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySubscriptionBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySubscriptionBenefitMutation, { data, loading, error }] = useDestroySubscriptionBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroySubscriptionBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroySubscriptionBenefitDocument, options);
}
export const GetBenefitDocument = gql `
    query GetBenefit($id: ID!) {
  benefit(id: $id) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useGetBenefitQuery__
 *
 * To run a query within a React component, call `useGetBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefitQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBenefitDocument, options);
}
export function useGetBenefitLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBenefitDocument, options);
}
export function useGetBenefitSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBenefitDocument, options);
}
export const LaunchBusinessDocument = gql `
    mutation LaunchBusiness($id: ID!) {
  launchBusiness(id: $id) {
    success
    error
    message
  }
}
    `;
/**
 * __useLaunchBusinessMutation__
 *
 * To run a mutation, you first call `useLaunchBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchBusinessMutation, { data, loading, error }] = useLaunchBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(LaunchBusinessDocument, options);
}
export const MembershipTierDocument = gql `
    query MembershipTier($id: ID!) {
  membershipTier(id: $id) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
/**
 * __useMembershipTierQuery__
 *
 * To run a query within a React component, call `useMembershipTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipTierQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipTierDocument, options);
}
export function useMembershipTierLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipTierDocument, options);
}
export function useMembershipTierSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipTierDocument, options);
}
export const MembershipTierImageDocument = gql `
    query MembershipTierImage($tierId: ID!) {
  membershipTier(id: $tierId) {
    id
    image {
      id
      url
      cdnPath
    }
  }
}
    `;
/**
 * __useMembershipTierImageQuery__
 *
 * To run a query within a React component, call `useMembershipTierImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTierImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTierImageQuery({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useMembershipTierImageQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipTierImageDocument, options);
}
export function useMembershipTierImageLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipTierImageDocument, options);
}
export function useMembershipTierImageSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipTierImageDocument, options);
}
export const JobFinishedDocument = gql `
    query JobFinished($id: ID!) {
  jobFinished(id: $id)
}
    `;
/**
 * __useJobFinishedQuery__
 *
 * To run a query within a React component, call `useJobFinishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobFinishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobFinishedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobFinishedQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(JobFinishedDocument, options);
}
export function useJobFinishedLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(JobFinishedDocument, options);
}
export function useJobFinishedSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(JobFinishedDocument, options);
}
export const MembershipTierShopifyProductDocument = gql `
    query MembershipTierShopifyProduct($id: ID!) {
  membershipTier(id: $id) {
    id
    shopifyProductId
  }
}
    `;
/**
 * __useMembershipTierShopifyProductQuery__
 *
 * To run a query within a React component, call `useMembershipTierShopifyProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTierShopifyProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTierShopifyProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipTierShopifyProductQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipTierShopifyProductDocument, options);
}
export function useMembershipTierShopifyProductLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipTierShopifyProductDocument, options);
}
export function useMembershipTierShopifyProductSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipTierShopifyProductDocument, options);
}
export const UpdateBenefitDocument = gql `
    mutation UpdateBenefit($id: ID!, $benefit: BenefitInput!) {
  updateBenefit(id: $id, benefit: $benefit) {
    __typename
    id
    name
  }
}
    `;
/**
 * __useUpdateBenefitMutation__
 *
 * To run a mutation, you first call `useUpdateBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBenefitMutation, { data, loading, error }] = useUpdateBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      benefit: // value for 'benefit'
 *   },
 * });
 */
export function useUpdateBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBenefitDocument, options);
}
export const UpdateBusinessDocument = gql `
    mutation UpdateBusiness($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...BusinessFragment
  }
}
    ${BusinessFragmentFragmentDoc}`;
/**
 * __useUpdateBusinessMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessMutation, { data, loading, error }] = useUpdateBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useUpdateBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBusinessDocument, options);
}
export const UpdateCoverPhotoDocument = gql `
    mutation UpdateCoverPhoto($businessId: ID!, $imageInput: ImageInput!) {
  updateCoverPhoto(businessId: $businessId, imageInput: $imageInput) {
    id
    coverPhoto {
      id
      url
      cdnPath
    }
  }
}
    `;
/**
 * __useUpdateCoverPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPhotoMutation, { data, loading, error }] = useUpdateCoverPhotoMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateCoverPhotoMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateCoverPhotoDocument, options);
}
export const UpdateLogoDocument = gql `
    mutation UpdateLogo($businessId: ID!, $imageInput: ImageInput!) {
  updateLogo(businessId: $businessId, imageInput: $imageInput) {
    id
    logo {
      id
      url
      cdnPath
    }
  }
}
    `;
/**
 * __useUpdateLogoMutation__
 *
 * To run a mutation, you first call `useUpdateLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogoMutation, { data, loading, error }] = useUpdateLogoMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateLogoMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateLogoDocument, options);
}
export const UpdateMembershipDocument = gql `
    mutation UpdateMembership($id: ID!, $membershipInput: MembershipTierInput) {
  updateOrCreateMembership(businessId: $id, membershipInput: $membershipInput) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membershipInput: // value for 'membershipInput'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateMembershipDocument, options);
}
export const UpdateMembershipTierImageDocument = gql `
    mutation UpdateMembershipTierImage($membershipTierId: ID!, $imageInput: ImageInput!) {
  updateMembershipTierImage(
    membershipTierId: $membershipTierId
    imageInput: $imageInput
  ) {
    ok
  }
}
    `;
/**
 * __useUpdateMembershipTierImageMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipTierImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipTierImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipTierImageMutation, { data, loading, error }] = useUpdateMembershipTierImageMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateMembershipTierImageMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateMembershipTierImageDocument, options);
}
